import { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { Step } from 'signup-constants/Step';
import { getStepData } from '../../step/getStepData';
import { getCurrentStep } from '../../store/flow/selectors';
import { getGuessedDataBiden } from '../../store/guessed-prefill/selectors';
import { getSignupDataValue } from '../../store/signup-data/selectors';
import { getClickedToSeeAll } from '../../store/typeahead/selectors';
import { Data } from 'signup-constants/signupData/Data';
export const STEPS_WITH_PREFILLABLE_CONTENT = [Step.Industry, Step.CompanyDomain, Step.CompanyName, Step.CompanySize];
export const usePrefilledContent = isStepDataPrefilled => {
  const stepKey = useSelector(getCurrentStep);
  const stepDataKeys = stepKey ? getStepData(stepKey) : [];
  const dataKey = stepDataKeys[0]; // so far each prefillable step has only one dataKey
  const guessedData = useSelector(state => dataKey ? getGuessedDataBiden(dataKey)(state) : null);
  const data = useSelector(state => dataKey ? getSignupDataValue(state, dataKey) : null);
  const [isGuessedDataInInput] = useState(dataKey ? guessedData === data : false);
  const [shouldShowPrefilledSubtitle, setShouldShowPrefilledSubtitle] = useState(dataKey ? guessedData === data : false);

  // Title
  const prefilledTitle = `views.${stepKey}.title.acq143-prefilled`;

  // Helpertext / Subtitle
  const prefilledHelperText = `views.${stepKey}.helperText`;
  const shouldShowPrefilledTitle = guessedData && stepKey === Step.Industry ? isStepDataPrefilled : isGuessedDataInInput && isStepDataPrefilled;
  const didNotClickToSeeAllIndustries = useSelector(state => !getClickedToSeeAll(state, Data.Industry) && stepKey === Step.Industry);
  useEffect(() => {
    if (didNotClickToSeeAllIndustries && isStepDataPrefilled && !shouldShowPrefilledSubtitle) {
      setShouldShowPrefilledSubtitle(true);
    }
  }, [didNotClickToSeeAllIndustries, guessedData, isStepDataPrefilled, shouldShowPrefilledSubtitle]);
  useEffect(() => {
    if (stepKey !== Step.Industry && guessedData !== data) {
      setShouldShowPrefilledSubtitle(false);
    }
  }, [data, guessedData, shouldShowPrefilledSubtitle, stepKey]);
  return {
    prefilledTitle,
    shouldShowPrefilledTitle,
    shouldShowPrefilledSubtitle,
    prefilledHelperText
  };
};